import classes from './FormApprovalComplete.module.css';
import { useTranslation } from 'react-i18next';
import TitleLine from '../../Assets/TitleLine/TitleLine';
import { useNavigate } from 'react-router-dom';
import { FaRegPaperPlane } from 'react-icons/fa';
import ReactLoading from 'react-loading';
import FormApprovalCompleteTop from './FormApprovalCompleteTop';
import { useRoutesContext } from '../../../contexts/RoutesContext';

interface Props {
    loading?: boolean,
}

const FormApprovalComplete = ({ loading }: Props) => {

    const { t } = useTranslation();

    // Set navigate for changing routes
    const navigate = useNavigate();

    // Get routes from routeContext
    const { routes } = useRoutesContext();

    const handleReturnBackToMain = () => {
        // Return back to main view
        navigate(`/${routes.main}`)
    };

    return (
        <div className={classes.formApprovalContainer}>
            <FormApprovalCompleteTop />

            <TitleLine />

            {loading ?
                <div className={classes.sendingApplicationContainer}>
                    <ReactLoading type={"spokes"} color={"#ED1B24"} height={'50px'} width={'50px'} />

                    <div className={classes.sendingApplicationText}>{t('formApproval.sendingApplication')}</div>
                </div>
                :
                <div className={classes.formApprovalIsSentContainer}>

                    <FaRegPaperPlane className={classes.icon} />

                    <div className={classes.isSentAndWaitingText}>
                        {t('formApproval.isSentAndWaitingForApproval')}
                    </div>
                    <div className={classes.youGetNotificationText}>
                        {t('formApproval.youGetNotificationWhenHandled')}
                    </div>

                    <div
                        className={classes.returnBackButton}
                        onClick={() => handleReturnBackToMain()}
                    >
                        {t("formApproval.returnBackToMain")}
                    </div>
                </div>
            }
        </div>
    );
};

export default FormApprovalComplete;